import React, { useEffect, useRef, useContext } from "react";

import ColourContext from "../../contexts/ColourContext";

import { colourThemes } from "../../styles/colourPalettes";
import style from "./ProfilePic.module.css";

export interface ProfilePicProps {
  src: string;
  size: number;
  isBlurred: boolean;
}

const ProfilePic = ({ src, size, isBlurred }: ProfilePicProps) => {
  // Transition the circle colour

  const { key: colourKey } = useContext(ColourContext);
  const colour = colourThemes[colourKey];

  // TODO: Update this so the colour fades.
  // useEffect(() => {
  //   gsap.to(".profilePicColour", {
  //     backgroundColor: colour,
  //     duration: 0.3,
  //   })
  // }, [colour])

  return (
    <div className={style.container} style={{ width: size, height: size }}>
      <div
        className="profilePicColour"
        style={{
          opacity: 1,
          filter: isBlurred ? "blur(8px)" : "",
          backgroundColor: colour,
        }}
      >
        <img src={src} alt="Profile" />
      </div>
      <div
        className="profilePicColour"
        style={{
          opacity: 0.3,
          filter: isBlurred ? "blur(4px)" : "",
          backgroundColor: colour,
        }}
      >
        <img src={src} alt="Profile pic background" />
      </div>
    </div>
  );
};

ProfilePic.defaultProps = {
  size: 88,
  isBlurred: false,
};

export default ProfilePic;
